export const createTypography = (colors: any) => ({
  MuiTypography: {
    h2: {
      fontSize: '1.125rem',
      fontWeight: 700,
    },
    h3: {
      fontSize: '0.875rem',
      fontWeight: 700,
    },
    h4: {
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '0.875rem',
      fontWeight: 400,
    },
    statNumber: {
      fontSize: '2.5rem',
      fontWeight: 900,
    },
    colorPrimary: {
      color: colors.mainText,
    },
    colorSecondary: {
      color: colors.secondaryText,
    },
  },
})
